import { render } from "./CropTreatmentForm.vue?vue&type=template&id=1a431319&scoped=true&ts=true"
import script from "./CropTreatmentForm.vue?vue&type=script&lang=ts"
export * from "./CropTreatmentForm.vue?vue&type=script&lang=ts"

import "./CropTreatmentForm.vue?vue&type=style&index=0&id=1a431319&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a431319"]])

export default __exports__